<template>
  <div>
    <NuxtPage />
    <ClientOnly>
      <ImtSearchModal />
      <ContentTooltip />
      <LazyErrorReporter v-if="$isPreview && $reporter.errors.length" :errors="$reporter.errors" />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import 'lazysizes'

const { $reporter, $isPreview } = useNuxtApp()
</script>

<style>
@screen lg {
  /**
    Load custom font on desktop. Both `Avenir Next` and `Monito` refers to
    the same font but only `Monito` is loaded through the @font-face rule.
  */
  body {
    font-family: 'Avenir Next', 'Monito', sans-serif;
  }
}

@font-face {
  font-family: 'Monito';
  src:
    local('Avenir Next'),
    url('/fonts/regular.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Monito';
  src:
    local('Avenir Next Medium'),
    url('/fonts/medium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Monito';
  src:
    local('Avenir Next Demi Bold'),
    url('/fonts/demi-bold.woff2') format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Monito';
  src:
    local('Avenir Next Bold'),
    url('/fonts/bold.woff2') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
</style>
